/** Utilidades puras del historial de periodos. */
/** Indica si se puede cargar el historial. */
export function canLoadHistory(module: unknown, group: unknown): boolean {
  return Boolean(module) && Boolean(group);
}

/** Normaliza filas a arreglo. */
export function asHistoryRows(value: unknown): unknown[] {
  if (value) return value as unknown[];
  return [];
}

/** Extrae estado de error. */
export function historyErrorStatus(err: { status?: unknown }): string {
  return String(err.status ?? 'sin estado');
}

/** Extrae detalle de error. */
export function historyErrorDetail(err: { error?: { error?: unknown } }): string {
  return String(err.error?.error ?? '');
}

/** Construye texto de error de historial. */
export function historyErrorText(err: { status?: unknown; error?: { error?: unknown } }): string {
  const status = historyErrorStatus(err);
  const detail = historyErrorDetail(err);
  return `No se pudo cargar el historial (${status}). ${detail}`;
}
